module.exports = __webpack_public_path__ + "static/media/logo2.5d5fa304.svg";